var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoutes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #667085;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.73,17.58h-12.49c-2.29,0-4.49.91-6.12,2.53-1.62,1.62-2.53,3.82-2.53,6.12s.91,4.49,2.53,6.12c1.62,1.62,3.82,2.53,6.12,2.53h13.45c1.27,0,2.5.51,3.4,1.41.9.9,1.41,2.12,1.41,3.4s-.51,2.5-1.41,3.4c-.9.9-2.12,1.41-3.4,1.41h-12.82c-.45-1.28-1.35-2.36-2.52-3.05-1.17-.69-2.55-.94-3.89-.71-1.34.23-2.56.93-3.43,1.97-.88,1.04-1.36,2.36-1.36,3.72s.48,2.68,1.36,3.72c.88,1.04,2.09,1.74,3.43,1.97,1.34.23,2.72-.02,3.89-.71,1.17-.69,2.07-1.77,2.52-3.05h12.82c2.29,0,4.49-.91,6.12-2.53,1.62-1.62,2.53-3.82,2.53-6.12s-.91-4.49-2.53-6.12c-1.62-1.62-3.82-2.53-6.12-2.53h-13.45c-1.27,0-2.5-.51-3.4-1.41-.9-.9-1.41-2.12-1.41-3.4s.51-2.5,1.41-3.4c.9-.9,2.12-1.41,3.4-1.41h12.49v5.77l9.61-7.69-9.61-7.69v5.77Zm-15.38,28.83c0,.51-.2,1-.56,1.36-.36.36-.85.56-1.36.56s-1-.2-1.36-.56c-.36-.36-.56-.85-.56-1.36s.2-1,.56-1.36c.36-.36.85-.56,1.36-.56s1,.2,1.36.56c.36.36.56.85.56,1.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutes);
export default __webpack_public_path__ + "static/media/routes.18e1a2d2474d53fc29a2a9fda959f4c8.svg";
export { ForwardRef as ReactComponent };